import type { AceBadgeId } from '@/lib/aces-data';
import { cn } from '@/lib/utils';

const BADGE_CONFIG: Record<
  AceBadgeId,
  { label: string; className: string; darkClassName: string }
> = {
  conta: {
    label: 'Conta',
    className: 'border-amber-200/80 bg-amber-50 text-amber-800',
    darkClassName: 'border-amber-500/25 bg-amber-950/40 text-amber-100',
  },
  chat: {
    label: 'Chat',
    className: 'border-indigo-200/80 bg-indigo-50 text-indigo-800',
    darkClassName: 'border-indigo-500/25 bg-indigo-950/40 text-indigo-100',
  },
  niveis: {
    label: 'Níveis',
    className: 'border-violet-200/80 bg-violet-50 text-violet-800',
    darkClassName: 'border-violet-500/25 bg-violet-950/40 text-violet-100',
  },
  renovacao: {
    label: 'Renovação',
    className: 'border-sky-200/80 bg-sky-50 text-sky-800',
    darkClassName: 'border-sky-500/25 bg-sky-950/40 text-sky-100',
  },
  novo: {
    label: 'Novo',
    className: 'border-emerald-200/80 bg-emerald-50 text-emerald-800',
    darkClassName: 'border-emerald-500/25 bg-emerald-950/40 text-emerald-100',
  },
};

type AceBadgeProps = {
  id: AceBadgeId;
  className?: string;
  variant?: 'light' | 'dark';
};

export function AceBadge({ id, className, variant = 'light' }: AceBadgeProps) {
  const cfg = BADGE_CONFIG[id];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 font-poppins text-[11px] font-semibold leading-none',
        variant === 'dark' ? cfg.darkClassName : cfg.className,
        className
      )}
    >
      {cfg.label}
    </span>
  );
}

export function AceBadgeRow({
  badges,
  className,
  variant = 'light',
}: {
  badges: AceBadgeId[];
  className?: string;
  variant?: 'light' | 'dark';
}) {
  if (!badges.length) return null;
  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {badges.map((id) => (
        <AceBadge key={id} id={id} variant={variant} />
      ))}
    </div>
  );
}
